import React, { useState } from "react";
import {
  FormControl,
  FormControlLabel,
  TextField,
  Button,
  Checkbox,
} from "@material-ui/core";
import { Link, withRouter } from "react-router-dom";
import { compose } from "recompose";

import { withFirebase } from "../Firebase";
import * as ROUTES from "../../constants/routes";
import LoadingOverlay from "react-loading-overlay";
import { useError } from "../ErrorProvider";
import utils from "../utils";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  topMargin: {
    marginTop: "36px",
  },
}));

const SignUpPage = () => (
  <div>
    <SignUpForm />
  </div>
);

const INITIAL_STATE = {
  firstName: "",
  lastName: "",
  email: "",
  passwordOne: "",
  passwordTwo: "",
  companyCode: "",
  termsOfService: false,
};

const SignUpFormBase = ({ firebase, history }) => {
  const [state, setState] = useState(INITIAL_STATE);
  const [loading, setLoading] = useState(false);
  const [passwordMismatch, setPasswordMismatch] = useState(false);
  const [passwordOneError, setPasswordOneError] = useState(false);
  const [passwordTwoError, setPasswordTwoError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const errorProvider = useError();

  const classes = useStyles();

  const onSubmit = (event) => {
    const { firstName, lastName, email, passwordOne, companyCode } = state;
    setLoading(true);

    firebase
      .verifyCompanyCode({ companyCode })
      .then(({ data }) => {
        if (data.valid) {
          return firebase
            .doCreateUserWithEmailAndPassword(email, passwordOne)
            .then((authUser) => {
              return firebase.setUser(authUser.user.uid, {
                firstName,
                lastName,
                email,
                companyCode,
              });
            })
            .then(() => {
              setState({ ...INITIAL_STATE });
              firebase
                .resolveRedirect()
                .then((redirectPath) => {
                  history.replace(redirectPath);
                })
                .catch((err) => {
                  console.log(err);
                  history.replace(ROUTES.USERDASHBOARD);
                });
            });
        } else {
          errorProvider.showError(
            "Invalid Company Code. Make sure you entered the correct code."
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        errorProvider.showError(error);
        setLoading(false);
      });

    event.preventDefault();
  };

  const onChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const validatePasswords = (event) => {
    setPasswordMismatch(state.passwordOne !== state.passwordTwo);
    setPasswordOneError(
      state.passwordOne.length > 0 && !utils.validatePassword(state.passwordOne)
    );
    setPasswordTwoError(
      state.passwordTwo.length > 0 && !utils.validatePassword(state.passwordTwo)
    );
  };

  const tosChange = (event) => {
    setState({ ...state, termsOfService: event.target.checked });
  };

  const isInvalid =
    state.passwordOne !== state.passwordTwo ||
    !utils.validatePassword(state.passwordOne) ||
    state.email === "" ||
    !utils.validateEmailAddress(state.email) ||
    state.firstName === "" ||
    state.lastName === "" ||
    state.companyCode === "" ||
    !!!state.termsOfService;

  return (
    <LoadingOverlay active={loading} spinner>
      <form onSubmit={onSubmit}>
        <TextField
          label="First Name"
          placeholder="First Name"
          name="firstName"
          variant="outlined"
          value={state.firstName}
          onChange={onChange}
          fullWidth
        />
        <TextField
          label="Last Name"
          placeholder="Last Name"
          name="lastName"
          variant="outlined"
          value={state.lastName}
          onChange={onChange}
          fullWidth
        />
        <TextField
          label="Email"
          placeholder="Email"
          name="email"
          variant="outlined"
          type="email"
          value={state.email}
          onChange={onChange}
          onBlur={() => {
            setEmailError(
              state.email !== "" && !utils.validateEmailAddress(state.email)
            );
          }}
          error={emailError}
          helperText={emailError ? "Enter a valid email address." : ""}
          fullWidth
        />
        <TextField
          label="Password"
          type="password"
          placeholder="Password"
          name="passwordOne"
          variant="outlined"
          value={state.passwordOne}
          onChange={onChange}
          onBlur={() => validatePasswords()}
          error={passwordOneError}
          helperText="Password must be at least 8 characters long"
          fullWidth
        />
        <TextField
          label="Confirm Password"
          type="password"
          placeholder="Confirm Password"
          name="passwordTwo"
          variant="outlined"
          value={state.passwordTwo}
          onChange={onChange}
          onBlur={() => validatePasswords()}
          error={passwordTwoError || passwordMismatch}
          helperText={passwordMismatch ? "Passwords don't match." : ""}
          fullWidth
        />
        <TextField
          label="Company Code"
          placeholder="Company Code"
          name="companyCode"
          variant="outlined"
          value={state.companyCode}
          onChange={onChange}
          fullWidth
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={state.termsOfService}
              onChange={tosChange}
              name="termsOfService"
              color="primary"
            />
          }
          label={
            <span>
              {" "}
              I have read and agree to the{" "}
              <Link target="_blank" to={ROUTES.TOS}>
                Terms of Service
              </Link>
            </span>
          }
        />
        <FormControl fullWidth>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={isInvalid}
            className={classes.topMargin}
          >
            Create My Account
          </Button>
        </FormControl>
      </form>
    </LoadingOverlay>
  );
};

const SignUpLink = () => (
  <span>
    New to Smart Squirrel?{" "}
    <Link to={ROUTES.HOME} replace={true}>
      Create An Account
    </Link>
  </span>
);

const SignUpForm = compose(withRouter, withFirebase)(SignUpFormBase);

export default SignUpPage;
export { SignUpForm, SignUpLink };
